import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { UnespCoreMessageService } from '@unesp/core'
import { Observable, throwError, map } from 'rxjs'
import { catchError } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class RequestInterceptorService implements HttpInterceptor {
  constructor(private unespCoreMessageService: UnespCoreMessageService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map(res => {
        if (res instanceof HttpResponse) {
          if (res.status === 205 && request.url.includes('auth')) {
            this.unespCoreMessageService.showMessageInfo(
              'Ajustamos alguns dados de acesso. Tente logar novamente.',
              undefined,
              5000
            )
          }
        }
        return res
      }),
      catchError(err => {
        return throwError(() => err)
      })
    )
  }
}
